// Chat 送信前同意声明内置模版（利用上の注意）
// 基于「GBase Support_利用上の注意（共通）」文档，公司名统一为「Sparticle 株式会社」，
// 并将「AI利用ガイドライン」文档中的联系邮箱 support@sparticle.com 合并进お問い合わせ章节。
// 修订模版文本时同步更新 CHAT_BUILTIN_CONSENT_VERSION（见 ../constants.ts），以强制重新同意

const JA = `# 利用上の注意

**GBase Support AI機能 共通ご利用ガイドライン**

## 1. 本ガイドラインの適用範囲

本ガイドラインは、GBase Supportが提供するAIチャット・音声応対・検索アシスタントなど、対話形式でAIが回答を生成するすべての機能（以下「本AI機能」）に共通して適用されます。本AI機能は、登録されたマニュアル・FAQ・社内資料等の情報に基づいて回答を自動生成するものであり、内容の正確性・完全性を保証するものではありません。

## 2. 個人情報・機密情報の入力禁止

本AI機能への入力内容は、回答生成や品質改善のために記録・処理される場合があります。以下に該当する情報は、本AI機能に入力しないでください。

- 氏名、住所、電話番号、メールアドレスなどの個人情報
- マイナンバー、パスポート番号、運転免許証番号などの識別情報
- クレジットカード番号、銀行口座情報などの決済・金融情報
- ID・パスワード、APIキー、社内システムの認証情報
- 社外秘の契約内容、未公開の経営情報、顧客リストなどの企業機密情報
- 健康状態、病歴などの要配慮個人情報

上記情報を誤って入力された場合は、速やかに管理者までご連絡ください。

## 3. 回答内容に関する免責事項

- 本AI機能の回答は生成AIにより自動作成されており、誤った情報や古い情報が含まれる可能性があります。
- 重要な意思決定や手続きを行う際は、必ず公式マニュアルまたは担当者に内容をご確認ください。
- 本AI機能の回答に起因して生じた損害について、運営者は一切の責任を負いません。

## 4. 入力データの取り扱い

- 入力内容は、回答生成および本AI機能の品質向上の目的でのみ利用されます。
- 入力内容を第三者に開示する場合は、関連法令および社内規程に従います。
- データの保存期間・削除方法については、別途定めるプライバシーポリシーをご確認ください。

## 5. お問い合わせ

本ガイドラインに関するご質問・ご不明点は、下記までお問い合わせください。

- Sparticle 株式会社
- メールアドレス：support@sparticle.com
- 東京都中央区日本橋

制定日：2026年7月1日
`;

// 多语言 map：目前仅提供日文原文，其它语言暂回退到日文；
// 后续补充翻译时按 i18n 语言 key（en / zh-Hans / ko / ...）加入此 map 即可
const CONTENT_MAP: Record<string, string> = {
  ja: JA,
};

/**
 * 根据 i18n 当前语言返回 Chat 声明 markdown 文本
 * - 未匹配的语言回退到日文（业务方原始文本）
 */
export function getChatConsentContent(lang: string | undefined | null): string {
  if (lang && CONTENT_MAP[lang]) return CONTENT_MAP[lang];
  return JA;
}
